import type { OneTimeProduct, AssertProduct } from '@/store/products'

declare const _prd_9S0XOkYSpnPv: {
	id: 'prd_9S0XO2DEV2kYSpnPv'
	ident: 'prd_9S0XOkYSpnPv'
	sku: 'simple_workbook_bundle_29_99_usd'
	type: 'one_time'
	price: {
		price_id: 'prc_yDng42DEV2VevUl7Y'
		amount: 49
		amount_usd: 29.99
		currency: 'USD'
		amount_with_discount: 29.99
		discount: 19.01
		promocode: 'BASE'
	}
}
type _check = AssertProduct<typeof _prd_9S0XOkYSpnPv, OneTimeProduct>
const prd_9S0XOkYSpnPv = { ident: 'prd_9S0XOkYSpnPv' } as typeof _prd_9S0XOkYSpnPv

export default prd_9S0XOkYSpnPv
